import { render } from "./MembersTable.vue?vue&type=template&id=9ba0d9ee&scoped=true"
import script from "./MembersTable.vue?vue&type=script&lang=ts"
export * from "./MembersTable.vue?vue&type=script&lang=ts"

import "./MembersTable.vue?vue&type=style&index=0&id=9ba0d9ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9ba0d9ee"

export default script